import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { ToastrService } from 'ngx-toastr';
import { SnowlogService } from '@app/services/snowlog.service';

@Component({
  selector: 'app-snow-log-remove-modal',
  templateUrl: './snow-log-remove-modal.component.html',
  styleUrls: ['./snow-log-remove-modal.component.css']
})
export class SnowLogRemoveModalComponent implements OnInit {

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private toastr: ToastrService,
    private snowlogService: SnowlogService
  ) { }

  snowLogAreaId: number
  snowLogId: number
  modalName: string = 'snowLogRemoveModal'

  clear(): void {
    this.snowLogId = null
    this.snowLogAreaId = null
    this.ngxSmartModalService.get(this.modalName).removeData();
  }

  remove(): void {
    if (!this.snowLogAreaId) {
      return;
    }

    this.snowlogService.delete(this.snowLogAreaId).subscribe(
      () => {
        this.toastr.success('Snöloggen har tagits bort.')
        this.ngxSmartModalService.get(this.modalName).removeData()
        this.ngxSmartModalService.setModalData({ success: true }, this.modalName)
        this.ngxSmartModalService.close(this.modalName)
      },
      (error) => {
        this.toastr.error('Det gick inte att ta bort snöloggen.');
      },
      () => {
        //complete
      }
    );
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.ngxSmartModalService.getModal(this.modalName).onOpen.subscribe((modal: NgxSmartModalComponent) => {
      let data = modal.getData()
      this.snowLogAreaId = data.snowLogAreaId;
      this.snowLogId = data.snowLogId
    });
  }


}
